function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as reductio from 'reductio';
export var GroupUtils = /*#__PURE__*/function () {
  function GroupUtils() {}

  GroupUtils.RemoveEmptyBins = function RemoveEmptyBins(src) {
    var f = function f() {
      return src.all().filter(function (d) {
        // return Math.abs(d.value) > 0.00001; // if using floating-point numbers
        return d.value !== 0; // if integers only
      });
    };

    return {
      all: f,
      bottom: f,
      top: f
    };
  };

  GroupUtils.sortByValueDesc = function sortByValueDesc(a, b) {
    if (a.value > b.value) {
      return -1;
    } else if (b.value > a.value) {
      return 1;
    } else {
      return 0;
    }
  };

  GroupUtils.RemoveEmptyBinsTopN = function RemoveEmptyBinsTopN(src, n, sortfunc) {
    if (typeof sortfunc === 'undefined') {
      sortfunc = this.sortByValueDesc;
    }

    var f = function f() {
      var src2 = src.all().filter(function (d) {
        return d.value !== 0 && d.value !== '';
      });
      src2.sort(sortfunc);

      if (n !== undefined) {
        return src2.slice(0, n - 1);
      } else {
        return src2;
      }
    };

    return {
      all: f,
      bottom: f,
      top: f
    };
  };

  GroupUtils.RemoveEmptyBinsByKey = function RemoveEmptyBinsByKey(src, key) {
    var f = function f() {
      return src.all().slice(0).filter(function (d) {
        return d.value[key] !== 0; // if integers only
      });
    };

    return {
      all: f,
      bottom: f,
      top: f
    };
  };

  GroupUtils.CalcMinMaxAvg = function CalcMinMaxAvg(valueAccessor) {
    return reductio().count(true).sum(valueAccessor).min(valueAccessor).max(true).avg(true);
  }
  /*
   * Method that helps when
   * `reductio()'s` `min()` and `max()` is hanging out the browser.
   * */
  ;

  return GroupUtils;
}();

_defineProperty(GroupUtils, "MinMaxGroup", {
  max: function max(dim, field) {
    return this.group('max', dim, field);
  },
  min: function min(dim, field) {
    return this.group('min', dim, field);
  },
  group: function group(method, dim, field) {
    if (method === void 0) {
      method = 'max';
    }

    return {
      value: function value() {
        var value;

        switch (method) {
          case 'min':
            value = dim.bottom(1)[0];
            break;

          case 'max':
          default:
            value = dim.top(1)[0];
        }

        return typeof value === 'object' && typeof value[field] === 'number' ? value[field] : 0;
      },
      all: function all() {
        return dim.all();
      }
    };
  }
});

export default GroupUtils;